import { z } from "zod";
import {
  AMOUNT,
  ATTACHMENT_FILE,
  BILLING_MONTH_YEAR,
  CHEQUE_NO,
  CLEARING,
  COMBINE,
  COMMENT,
  CUSTOMER_ACC,
  DATE,
  DOCUMENT_TYPE,
  DRCR,
  GL_ACCOUNT,
  JOURNAL_ENTRY_FILE,
  LINE_ITEM_TEXT,
  LINE_ITEMS,
  OL_REF,
  OL_TOTAL,
  PAYMENT_METHOD,
  POSTING_DATE,
  POSTING_MONTH,
  SUB_LEDGER,
  VENDOR_ACC,
  YEAR,
} from "./consts";

export const schema = z.object({
  [DOCUMENT_TYPE]: z.string().min(1, "This field is required"),
  [BILLING_MONTH_YEAR]: z.any().refine((val) => !!val, {
    message: "This field is required",
  }),
  [COMMENT]: z.string().min(1, "This field is required"),
  [ATTACHMENT_FILE]: z.any().refine((val) => !!val, {
    message: "This field is required",
  }),
  [JOURNAL_ENTRY_FILE]: z.any().refine((val) => !!val, {
    message: "This field is required",
  }),
  [POSTING_DATE]: z.any().refine((val) => !!val, {
    message: "This field is required",
  }),
  [POSTING_MONTH]: z.string().optional(),
  [YEAR]: z.string().optional(),
  [LINE_ITEMS]: z
    .object({
      [DATE]: z.any().optional(),
      [LINE_ITEM_TEXT]: z.string().optional(),
      [CHEQUE_NO]: z.string().optional(),
      [AMOUNT]: z.string().optional(),
      [DRCR]: z.string().optional(),
      [GL_ACCOUNT]: z.string().optional(),
      [SUB_LEDGER]: z.boolean().optional(),
      [COMBINE]: z.boolean().optional(),
      [CUSTOMER_ACC]: z.string().optional(),
      [VENDOR_ACC]: z.string().optional(),
      [PAYMENT_METHOD]: z.string().optional(),
      [CLEARING]: z.string().optional(),
      [OL_REF]: z.string().optional(),
      [OL_TOTAL]: z.string().optional(),
    })
    .array(),
});

export type formValues = z.infer<typeof schema>;
